module.exports = __webpack_public_path__ + "img/logout.76bb5eb3.svg";